import smallmv from "/assets/videos/hero3.mp4";
// import highlightFirstmv from "/assets/videos/highlight-first.mp4";
// import highlightThirdmv from "/assets/videos/hightlight-fourth.mp4";
// import highlightFourthmv from "/assets/videos/hightlight-fourth.mp4";
import apple from "/assets/images/apple.svg";
import search from "/assets/images/search.svg";
import bag from "/assets/images/bag.svg";
import watch from "/assets/images/watch.svg";
import right from "/assets/images/right.svg";
import replay from "/assets/images/replay.svg";
import play from "/assets/images/play.svg";
import pause from "/assets/images/pause.svg";
import explore1 from "/assets/images/explore1.jpg";
import explore2 from "/assets/images/explore2.png";
import chip from "/assets/images/chip.png";
import frame from "/assets/images/frame.png";
export const smallHeroVideo = smallmv;
// export const highlightFirstVideo = highlightFirstmv;
// export const highlightThirdVideo = highlightThirdmv;
// export const highlightFourthVideo = highlightFourthmv;
export const appleImg = apple;
export const searchImg = search;
export const bagImg = bag;
export const watchImg = watch;
export const rightImg = right;
export const replayImg = replay;
export const playImg = play;
export const pauseImg = pause;
export const explore1Img = explore1;
export const explore2Img = explore2;
export const chipImg = chip;
export const frameImg = frame;